import {AfterViewInit, Component, Injector, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {NewCertificationService} from "./services/new-certification.service";

@Component({
    selector: 'app-new-certification-detail-dashboard',
    templateUrl: './new-cert-dashboard.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertDashboardComponent extends BaseComponentDirective implements OnInit, AfterViewInit, OnChanges {

    @Input() attendanceTypes: any = {};
    @Input() associations: any[] = [];
    @Input() certification: any = null;
    @Input() activities: any[] = [];
    @Input() restricted = 0;

    providerId: any = null;
    totalObjectives = 0;
    totalDomains = 0;
    totalTerms = 0;
    totalActivities = 0;

    constructor(
        injector: Injector,
        private svc: NewCertificationService
    ) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.svc.countActivities(this.certification.id).then(r => {
            this.totalActivities = r.value;
        })
        this.svc.countDomains(this.certification.id).then(r => {
            this.totalDomains = r.value;
        })

        this.svc.countObjectives(this.certification.id).then(r => {
            this.totalObjectives = r.value;
        })

        this.svc.countTerms(this.certification.id).then(r => {
            this.totalTerms = r.value;
        })
    }

    ngAfterViewInit() {
        setTimeout(() => {
            console.log(this.activities.length, this.certification);
        }, 2000)

    }
}
